// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.food_session_status_enum */
var FoodSessionStatusEnum;
(function (FoodSessionStatusEnum) {
    FoodSessionStatusEnum["unstarted"] = "unstarted";
    FoodSessionStatusEnum["in_progress"] = "in_progress";
    FoodSessionStatusEnum["review"] = "review";
    FoodSessionStatusEnum["completed"] = "completed";
})(FoodSessionStatusEnum || (FoodSessionStatusEnum = {}));
;
export default FoodSessionStatusEnum;
/** Zod schema for food_session_status_enum */
export const foodSessionStatusEnum = z.nativeEnum(FoodSessionStatusEnum);
//# sourceMappingURL=FoodSessionStatusEnum.js.map